import { createFeatureSelector, createSelector } from '@ngrx/store';
import { IDialogsState } from './dialogs.reducer';

export const selectDialog = createFeatureSelector('dialogs');

export const getDialog = createSelector(
  selectDialog,
  (dialog: IDialogsState) => {
    return dialog
  }
)



